/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import { useMemo, useState } from 'react';

import {
  AccessAutocomplete,
  PrimaryButton,
  SecondaryButton,
  Typography,
} from '@changegps/horizon-component-library';
import { zodResolver } from '@hookform/resolvers/zod';
import { Box } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { ControlledInputs } from '@/components';
import { coreLettersAxiosClient } from '@/lib/axios';
import { StringRequiredSchema } from '@/utils';

const letterTemplateSchema = z.object({
  name: StringRequiredSchema('Please enter a name.'),
  subject: StringRequiredSchema('Please enter a subject.'),
  sub_header: StringRequiredSchema('Please enter a sub-header.'),
  content: z.string(),
});

type LetterTemplateForm = z.infer<typeof letterTemplateSchema>;

const LetterTemplateDefaultValues: LetterTemplateForm = {
  name: '',
  subject: '',
  sub_header: '',
  content: '',
};

interface SaveTemplatePayload {
  category_id: string;
  header: string;
  subheader: string;
  name: string;
  content: string;
}

interface LetterTemplatesProps {
  data?: any[];
}

export const CreateLetterTemplate = ({ data }: LetterTemplatesProps) => {
  const [selectedCategory, setSelectedCategory] = useState<string>('');

  const {
    control,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<LetterTemplateForm>({
    resolver: zodResolver(letterTemplateSchema),
    defaultValues: LetterTemplateDefaultValues,
    reValidateMode: 'onBlur',
    disabled: false,
  });

  const saveLetterMutation = useMutation({
    mutationFn: (formData: SaveTemplatePayload) => {
      return coreLettersAxiosClient.post(`/settings/merge`, formData);
    },
    onSuccess: (response) => {
      window.console.log('Template created successfully:', response);
      // Reset form or show success message
    },
    onError: (error) => {
      window.console.error('Error creating template:', error);
    },
  });

  const categoryOptions = useMemo(() => {
    if (data) {
      return data.map((item: { name: string; id: string }) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
    }
    return [];
  }, [data]);

  const onSubmit = (values: LetterTemplateForm) => {
    if (!selectedCategory) {
      // Show error message for missing category
      return;
    }

    const payload: SaveTemplatePayload = {
      category_id: selectedCategory,
      header: values.subject,
      subheader: values.sub_header,
      name: values.name,
      content: values.content,
    };

    saveLetterMutation.mutate(payload);
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      sx={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: 2 }}
    >
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <Box sx={{ width: '100%' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
            Category:
          </Typography>
          <AccessAutocomplete
            options={categoryOptions}
            onChange={(_event, value) => {
              if (value) {
                // @ts-expect-error value structure
                setSelectedCategory(value.value);
              } else {
                setSelectedCategory('');
              }
            }}
            TextFieldProps={{
              placeholder: 'Select a category',
            }}
          />
        </Box>
        <Box sx={{ width: '100%' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
            Name:
          </Typography>
          <ControlledInputs.TextField
            ControllerProps={{
              control,
              name: `name`,
            }}
            fullWidth
            error={!!errors.name}
            helperText={errors.name?.message}
          />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', gap: 2 }}>
        <Box sx={{ width: '100%' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
            Subject:
          </Typography>
          <ControlledInputs.TextField
            ControllerProps={{
              control,
              name: `subject`,
            }}
            fullWidth
            error={!!errors.subject}
            helperText={errors.subject?.message}
          />
        </Box>
        <Box sx={{ width: '100%' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
            Sub-header:
          </Typography>
          <ControlledInputs.TextField
            ControllerProps={{
              control,
              name: `sub_header`,
            }}
            fullWidth
            error={!!errors.sub_header}
            helperText={errors.sub_header?.message}
          />
        </Box>
      </Box>
      <ControlledInputs.TextEditor
        ControllerProps={{
          control,
          name: `content`,
        }}
        modules={{
          toolbar: [
            ['bold', 'italic'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['code-block'],
          ],
        }}
      />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <SecondaryButton>View all merge fields</SecondaryButton>
        <PrimaryButton type="submit" disabled={saveLetterMutation.isPending}>
          {saveLetterMutation.isPending ? 'Creating...' : 'Create Template'}
        </PrimaryButton>
      </Box>
    </Box>
  );
};
